import Button from "@/components/Button/index";
import Modal from "@/dsComponents/Modal";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { ErrorOutlineOutlined } from "@dextech-ai/dex-design-system/icons";
import rem from "@/utils/rem";

const ExcludeAllEtrIssuance = ({ visible, hide, handleSubmit }) => {
	return (
		<Modal visible={visible} close={hide}>
			<ModalHeader icon={<ErrorOutlineOutlined color="error" />}>
				<ModalTitle>Exclude All Blockchain</ModalTitle>
			</ModalHeader>
			<ModalBody>
				<div>
					<div className="etr-issuance-modal__content center">
						<p>
							By disabling all the blockchains, your organization will lose the capability to issue Electronic Transaction Records (ETRs).
						</p>
						<p>
							Please confirm that you wish to proceed.
						</p>
					</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<ModalFooterRight>
					<div className="exclude-modal__confirmation_actions">
						<Button
							data-testid="etr-issuance-cancel"
							ghost
							round
							noborder
							reject
							submit={() => hide()}
							text="Cancel"
						/>
						<Button
							data-testid="etr-issuance-confirm"
							full
							round
							error
							submit={() => {
								handleSubmit()
								hide()
							}}
							text="Confirm"
						/>
					</div>
				</ModalFooterRight>
			</ModalFooter>
		</Modal>
	);
};

export default ExcludeAllEtrIssuance;
